'use strict';

import { Entity } from '../Entity';
import { Agency } from './Agency';

export class AgencyAgencyDownline extends Entity {
  protected id;

  protected agencyUpline;

  protected agencyAbsoluteUpline;

  protected agency;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    if (data.agency) {
      const agency = new Agency();

      agency.hydrate(data.agency);

      this.agency = agency;
    }

    if (data.agencyUpline) {
      const agencyUpline = new Agency();

      agencyUpline.hydrate(data.agencyUpline);

      this.agencyUpline = agencyUpline;
    }

    if (data.agencyAbsoluteUpline) {
      const agencyAbsoluteUpline = new Agency();

      agencyAbsoluteUpline.hydrate(data.agencyAbsoluteUpline);

      this.agencyAbsoluteUpline = agencyAbsoluteUpline;
    }

    /*this.agencyUpline = data.agencyUpline;

        this.agencyAbsoluteUpline = data.agencyAbsoluteUpline;

        this.agency = data.agency;*/
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getAgencyUpline() {
    return this.agencyUpline;
  }

  public setAgencyUpline(agencyUpline) {
    this.agencyUpline = agencyUpline;

    return this;
  }

  public getAgencyAbsoluteUpline() {
    return this.agencyAbsoluteUpline;
  }

  public setAgencyAbsoluteUpline(agencyAbsoluteUpline) {
    this.agencyAbsoluteUpline = agencyAbsoluteUpline;

    return this;
  }

  public getAgency() {
    return this.agency;
  }

  public setAgency(agency) {
    this.agency = agency;

    return this;
  }
}
